import React from 'react';
import { RouteProps } from 'react-router';
import { Navigate } from 'react-router-dom';
import { routerPath } from '@/shared/config/router';
import { HomePage } from '@/pages/HomePage';
import { LoginPage } from '@/pages/LoginPage';
import { ApplicantsPage } from '@/pages/ApplicantsPage';
import { CalendarPage } from '@/pages/CalendarPage';
import { CoursesPage } from '@/pages/CoursesPage';
import CourseDetailPage from '@/pages/CourseDetailPage';
import GroupPage from '@/pages/GroupPage';
import TermDetailPage from '@/pages/TermDetailPage';
import ModuleDetailPage from '@/pages/ModuleDetailPage';
import ModuleLessonPreviewPage from '@/pages/ModuleLessonPreviewPage';
import SessionAttendancePage from '@/pages/SessionAttendancePage';
import { AttendancePage } from '@/pages/AttendancePage';
import { NotificationsPage } from '@/pages/NotificationsPage';
import { MyNotificationsPage } from '@/pages/MyNotificationsPage';
import { ActivePage } from '@/pages/ActivePage';
import { ProfilesPage } from '@/pages/ProfilesPage';
import { GrowthSystemPage } from '@/pages/GrowthSystemPage';
import { AcademicStaffPage } from '@/pages/AcademicStaffPage';
import { SettingsPage } from '@/pages/SettingsPage';
import { CertificatesPage } from '@/pages/CertificatesPage';
import CertificatesCoursePage from '@/pages/CertificatesCoursePage';
import { ScheduleEventsPage } from '@/pages/ScheduleEventsPage';
import { ChatsPage } from '@/pages/ChatsPage';
import { CommunityPage } from '@/pages/CommunityPage';
import { CareerHubPage } from '@/pages/CareerHubPage';
import { LocationsPage } from '@/pages/LocationsPage';
import { LocationDetailPage } from '@/pages/LocationDetailPage';
import AssignmentDetailPage from '@/pages/AssignmentDetailPage';
import ForgotPasswordPage from '@/pages/ForgotPasswordPage';
import ResetPasswordPage from '@/pages/ResetPasswordPage';
import SetPasswordPage from '@/pages/SetPasswordPage';
import { AdministrationPage } from '@/pages/AdministrationPage';
import { OperationsCenterPage } from '@/pages/OperationsCenterPage';
import { AttributesCategoriesPage } from '@/pages/AttributesCategoriesPage';
import { AttributesDifficultyLevelsPage } from '@/pages/AttributesDifficultyLevelsPage';
import { AttributesHashtagsPage } from '@/pages/AttributesHashtagsPage';
import { RequestsReportsPage } from '@/pages/RequestsReportsPage';
import { PaymentsPage } from '@/pages/PaymentsPage';
import { ArticlesNewsPage } from '@/pages/ArticlesNewsPage';
import { ArticlesBlogPage } from '@/pages/ArticlesBlogPage';
import { ArticleFormPage } from '@/pages/ArticleFormPage';
import { ArticlePreviewPage } from '@/pages/ArticlePreviewPage';
export type TypeRouteConfig = RouteProps & {
  isAuth?: boolean;
};

export const routeConfig: TypeRouteConfig[] = [
  {
    path: routerPath.main,
    element: <HomePage />,
    isAuth: true,
  },
  {
    path: routerPath.courses,
    element: <CoursesPage />,
    isAuth: true,
  },
  {
    path: routerPath.courseDetail,
    element: <CourseDetailPage />,
    isAuth: true,
  },
  {
    path: routerPath.groupDetail,
    element: <GroupPage />,
    isAuth: true,
  },
  {
    path: routerPath.termDetail,
    element: <TermDetailPage />,
    isAuth: true,
  },
  {
    path: routerPath.moduleDetail,
    element: <ModuleDetailPage />,
    isAuth: true,
  },
  {
    path: routerPath.moduleLessonPreview,
    element: <ModuleLessonPreviewPage />,
    isAuth: true,
  },
  {
    path: routerPath.sessionAttendance,
    element: <SessionAttendancePage />,
    isAuth: true,
  },
  {
    path: routerPath.attendance,
    element: <AttendancePage />,
    isAuth: true,
  },
  {
    path: routerPath.login,
    element: <LoginPage />,
  },
  {
    path: routerPath.forgotPassword,
    element: <ForgotPasswordPage />,
  },
  {
    path: routerPath.resetPassword,
    element: <ResetPasswordPage />,
  },
  {
    path: routerPath.setPassword,
    element: <SetPasswordPage />,
  },
  {
    path: routerPath.active,
    element: <ActivePage />,
    isAuth: true,
  },
  {
    path: routerPath.applicants,
    element: <ApplicantsPage />,
    isAuth: true,
  },
  {
    path: routerPath.profiles,
    element: <ProfilesPage />,
    isAuth: true,
  },
  {
    path: routerPath.growthSystem,
    element: <GrowthSystemPage />,
    isAuth: true,
  },
  {
    path: routerPath.academicStaff,
    element: <AcademicStaffPage />,
    isAuth: true,
  },
  {
    path: routerPath.administration,
    element: <AdministrationPage />,
    isAuth: true,
  },
  {
    path: routerPath.operationsCenter,
    element: <OperationsCenterPage />,
    isAuth: true,
  },
  {
    path: routerPath.attributesCategories,
    element: <AttributesCategoriesPage />,
    isAuth: true,
  },
  {
    path: routerPath.attributesDifficultyLevels,
    element: <AttributesDifficultyLevelsPage />,
    isAuth: true,
  },
  {
    path: routerPath.attributesHashtags,
    element: <AttributesHashtagsPage />,
    isAuth: true,
  },
  {
    path: routerPath.assignmentsTest,
    element: <CalendarPage />,
    isAuth: true,
  },
  {
    path: routerPath.assignmentDetail,
    element: <AssignmentDetailPage />,
    isAuth: true,
  },
  {
    path: routerPath.certificates,
    element: <CertificatesPage />,
    isAuth: true,
  },
  {
    path: routerPath.certificatesCourse,
    element: <CertificatesCoursePage />,
    isAuth: true,
  },
  {
    path: routerPath.scheduleEvents,
    element: <ScheduleEventsPage />,
    isAuth: true,
  },
  {
    path: routerPath.chats,
    element: <ChatsPage />,
    isAuth: true,
  },
  {
    path: routerPath.community,
    element: <CommunityPage />,
    isAuth: true,
  },
  {
    path: routerPath.articlesNews,
    element: <ArticlesNewsPage />,
    isAuth: true,
  },
  {
    path: routerPath.articlesNewsCreate,
    element: <ArticleFormPage />,
    isAuth: true,
  },
  {
    path: routerPath.articlesNewsEdit,
    element: <ArticleFormPage />,
    isAuth: true,
  },
  {
    path: routerPath.articlesNewsDetail,
    element: <ArticlePreviewPage />,
    isAuth: true,
  },
  {
    path: routerPath.articlesBlog,
    element: <ArticlesBlogPage />,
    isAuth: true,
  },
  {
    path: routerPath.articlesBlogCreate,
    element: <ArticleFormPage />,
    isAuth: true,
  },
  {
    path: routerPath.articlesBlogEdit,
    element: <ArticleFormPage />,
    isAuth: true,
  },
  {
    path: routerPath.articlesBlogDetail,
    element: <ArticlePreviewPage />,
    isAuth: true,
  },
  {
    path: routerPath.careerHub,
    element: <CareerHubPage />,
    isAuth: true,
  },
  {
    path: routerPath.pushNotifications,
    element: <NotificationsPage />,
    isAuth: true,
  },
  {
    path: routerPath.myNotifications,
    element: <MyNotificationsPage />,
    isAuth: true,
  },
  {
    path: routerPath.locations,
    element: <LocationsPage />,
    isAuth: true,
  },
  {
    path: routerPath.locationDetail,
    element: <LocationDetailPage />,
    isAuth: true,
  },
  {
    path: routerPath.settings,
    element: <SettingsPage />,
    isAuth: true,
  },
  {
    path: routerPath.requestsReports,
    element: <RequestsReportsPage />,
    isAuth: true,
  },
  {
    path: routerPath.payments,
    element: <PaymentsPage />,
    isAuth: true,
  },
  {
    path: routerPath.administration,
    element: <AdministrationPage />,
    isAuth: true,
  },
  {
    path: routerPath.not_found,
    element: <Navigate to={routerPath.main} replace />,
    isAuth: true,
  },
];
